<template>
<div class="wrapper">
  <cabecalho tituloPagina="Agenda" />
  <menuLateral />

  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <b-button class="botoes ml-2" variant="outline-primary btn-sm" @click="voltarCalendario()" :disabled="flagsDeControle.carregandoDados.status">Calendário</b-button>
          </div>
        </div>
      </div>
    </section>
    <section class="content">
      <div class="card">
        <div class="card-body">
          <div v-if="flagsDeControle.carregandoDados.status" class="d-flex align-items-center">
            <span class="avisoDanger">{{flagsDeControle.carregandoDados.mensagem}}</span>
            <b-spinner class="ml-2" variant="danger"></b-spinner>
          </div>
          <default-table
            :items="listaDeConvites"
            :fields="fields"
            :sort-by="componenteOrdenacao.campo"
            :sort-direction="componenteOrdenacao.sentido"
            :busy="flagsDeControle.carregandoDados.status"
            @sortChanged="ordenarLista"
            :tbody-tr-class="tabelaSemRegistros">
            <template #empty>
              <em>Nenhum registro encontrado.</em>
            </template>
            <template #cell(f_summary)="row">
              <span>{{ row.item.f_summary }}</span>
            </template>
            <template #cell(f_dtstart)="row">
              <span>{{ formatarDataHora(row.item.f_dtstart) }}</span>
            </template>
            <template #cell(f_dtend)="row">
              <span>{{ formatarDataHora(row.item.f_dtend) }}</span>
            </template>
            <template #cell(f_status)="row">
              <span>{{ traduzirStatusConvite(row.item) }}</span>
            </template>
            <template #cell(options)="row">
              <b-form-group class="container-fluid d-flex justify-content-around">
                <b-form-radio-group
                  name="radio-btn-stacked"
                  size="sm"
                  value-field="value" text-field="text"
                  v-model="row.item.situacao"
                  buttons
                  @change="adicionarItemSelecionado(row.item)"
                >
                <template>
                  <slot v-if="ehConvitePendente(row.item)">
                    <b-form-radio :value="statusConvites.aceito" button-variant="outline-success">
                      Aceitar
                    </b-form-radio>
                    <b-form-radio :value="statusConvites.rejeitado" button-variant="outline-danger">
                      Negar
                    </b-form-radio>
                  </slot>
                  <slot v-else-if="ehNotificacaoPendente(row.item)">
                    <b-form-radio :value="statusConvites.notificacaoLeituraConfirmada" button-variant="outline-success">
                      Ok
                    </b-form-radio>
                  </slot>
                  <slot v-else-if="ehNotificacaoCancelada(row.item)">
                    <b-form-radio :value="statusConvites.notificacaoLeituraCancelamento" button-variant="outline-success">
                      Ok
                    </b-form-radio>
                  </slot>
                  <b-form-radio :value="null" button-variant="outline-secondary">
                    Ignorar
                  </b-form-radio>
                </template>
                </b-form-radio-group>
              </b-form-group>
            </template>
          </default-table>

          <div class="text-right ml-auto">
            <b-button variant="outline-success" class="ml-auto" :disabled="desabilitarBotaoSalvar" @click="salvarEmLote"> Salvar em lote </b-button>
          </div>
          <pagination :fonteDeDados="componentePaginacao.fonteDeDados" :disabled="flagsDeControle.carregandoDados.status" @navegarNaPaginacao="obterDadosPaginados"/>
        </div><!-- /.card-body -->
      </div><!-- /.card -->
    </section>
  </div>
</div>
</template>

<script>
import Convites from './js/convites'
export default Convites
</script>

<style scoped>
@import "./scss/convites.scss";
</style>
